(function (angular) {
    'use strict';

    angular.module('verifyReports')
        .factory('smsVerifyService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;

                var mockedData = [
                    { "date": "2018-10-13T00:00:00.000Z", "locked": 953, "verified": 467, "expired": 137 },
                    { "date": "2018-10-14T00:00:00.000Z", "locked": 1146, "verified": 479, "expired": 198 },
                    { "date": "2018-10-15T00:00:00.000Z", "verified": 4220, "clicks": 1105, "notVerified": 491 },
                    { "date": "2018-10-16T00:00:00.000Z", "verified": 2905, "locked": 705, "expired": 330 },
                    { "date": "2018-10-17T00:00:00.000Z", "verified": 2593, "locked": 495, "expired": 274 },
                    { "date": "2018-10-18T00:00:00.000Z", "expired": 40, "locked": 10, "notVerified": 6 }];

                var fac = {
                    getQueriedData: getQueriedData,
                };
                return fac;


                function getQueriedData(id, data) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/sms/verify?from=" + data.from.value.toISOString() + "&to=" + data.to.value.toISOString() + "&by=" + data.by;
                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);

                    function getQueriedDataComplete(response) {
                        return response.data;
                    }

                    function getQueriedDataFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }
            }
        ]);
})(window.angular);